<template>
	<el-dialog :visible.sync="showwin" title="增值服务" width="550px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
		<div style="min-height:300px;" class="addedservice_order">
			<table style="width:100%;margin-top:-30px;">
				<tr>
					<td style="width:60px">
						<label style="font-size:16pt;font-weight: bold;">单 号</label>
					</td>
					<td>
						<el-input style="font-size: 16pt;font-weight: 800;"
							v-model="p_pkval"
							@keyup.enter.native="getorderinfo"
						></el-input>
					</td>
					<td style="width:100px">
						<el-checkbox v-model="sendremind" :true-label="1" :false-label="0">发送提醒</el-checkbox>
					</td>
				</tr>
			</table>
			<addedservice ref="addedservice" @servicehandle="servicehandle"></addedservice>
		</div>
		<span slot="footer" class="dialog-footer">
			 <div style="text-align: center;">
				 <el-button type="success" @click="handledserviceall">全部已处理</el-button>
				 <el-button type="primary" @click="showwin=false">部分处理</el-button>
			 </div>
		 </span>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
import addedservice from '@/components/baseinfo/addedservice.vue';
export default {
	components: {
		addedservice
	},
	props: {
	},
	data() {
		return {
			showwin:false,
			p_pkval:'',
			userid:localStorage.getItem('userid'),
			sendremind:0,
			orderinfo:{},
			q_id:''
		}
	},
	mounted() {
		
	},
	methods: {
		//加载服务
		init(param){
			if(this.$refs.addedservice!=undefined){
				this.$refs.addedservice.servicelist=[];
			}
			this.sendremind=0;
			this.p_pkval='';
			this.orderinfo={};
			if(param.p_pkval!=undefined){
				this.p_pkval=param.p_pkval;
			}
			this.showwin=true;
			//根据订单信息判断订单是否可以提交增值服务
			this.getorderinfo();
		},
		//按单号获取增值服务
		getorderinfo(){
			var that=this;
			this.$tool.loading('正在加载', 'addedservice_order');
			this.$apipost.get.GetOrderInfo({ pkval: this.p_pkval}).then(res => {
				this.$tool.loadingclose();
				if(res.orderinfo!=undefined){
					that.orderinfo=res.orderinfo;
					if(that.orderinfo.main!=undefined){
						var intercept=that.orderinfo.main.intercept;
						if(intercept!=undefined)
						{
							that.q_id=intercept.split('★')[0];
							if(that.q_id!=undefined){
								that.q_id=that.q_id.replace('服务单号：','').replace(',','');
							}
						}
					}
					var addedservice=res.orderinfo.extend.addedservice;
					if(addedservice==undefined)
						addedservice='';
					if(addedservice!='')
						addedservice=JSON.stringify(addedservice);
					this.$nextTick(function() {
						that.$refs.addedservice.init({p_pkval:this.p_pkval,vertical:true,loadall:false,changeresult:true,servicelist:addedservice});
					});
				}
				else
					this.$tool.message(res.message, 0);
			});
		},
		//全部已处理
		handledserviceall(){
			var that=this;
			this.$confirm('确定增值服务已全部处理完成吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			})
				.then(() => {
					that.saveservice(true);
				});
		},
		//保存增值服务设置
		saveservice(isall,item){
			var selecteditem=this.$refs.addedservice.servicelist.filter(function(e){return e.ischecked==true});
			if(isall) //全部都变为已处理
			{
				selecteditem.forEach(e=>{
					e.handled=true;
				});
			}
			var that=this;
			var paraminfo={
				userid:localStorage.getItem('userid'),
				servicelist:selecteditem,
				pkval:this.p_pkval,
				q_id:this.q_id,
				type:2 //内部人员或者操作人员修改增值服务
			}
			this.$tool.loading('正在保存', 'addedservice_order');
			this.$apipost.post.SaveOrderService({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if(res.state=='1')
					{
						//是否全部已处理
						if(isall){
							that.handledall();
						}else{
							if(that.sendremind==1){
								var paraminfo=that.orderinfo;
								if(item!=undefined)
									paraminfo.item=item;
								that.$tool.SendMessage('283-1',paraminfo,that);
							}
							this.$tool.message('保存成功', 1);
						}
					}else{
						this.$tool.message(res.message, 0);
						item.handled=false;
					}
				}
			});
		},
		//开启关闭已操作时触发保存和发送提醒功能
		servicehandle(item){
			//debugger
			this.saveservice(false,item);
		},
		//将此订单对应的服务单结束，并将对应的订单的增值服务全部都更新为已处理
		handledall(){
			var that=this;
			this.$tool.loading('正在处理', 'addedservice_order');
			this.$apipost.post.SaveOrderService_All({paraminfo:{p_pkval:this.p_pkval, intercept:this.orderinfo.main.intercept,userid:this.userid}}).then(res => {
				if(res.state=='1'){
					this.$tool.message('全部处理完成', 1);
					that.showwin=false;
					if(that.sendremind==1){
						var paraminfo=that.orderinfo;
						paraminfo.item={d_name:'全部'};
						that.$tool.SendMessage('283-1',paraminfo);
					}
				}else{
						this.$tool.message(res.message, 0);
					}
			});
		}
	}
}
</script>
